import React from 'react';
import { Box, Heading, Body } from '@hover/blueprint';

const IHeading = () => (
  <Box d="block" textAlign="center" maxW="720px" mx="auto">
    <Heading
      mb={{ base: 2, desktop: 8 }}
      size={{ base: 400, tablet: 600, desktop: 700 }}
    >
      Integrations
    </Heading>
    <Body size={600}>
      Our integration partnerships represent the merging of game-changing
      technologies to make workflows more efficient. These integrations are easy
      to set up, so we can start helping people right away.
    </Body>
  </Box>
);

export default IHeading;
